{
  "admin_user": {
    "title": "Utilisateurs admin",
    "subtitle": "Comptes du personnel",
    "columns": {
      "name": "Nom",
      "email": "Email",
      "role": "Rôle",
      "roleType": "Type de rôle",
      "saleAssigned": "Commercial assigné",
      "csAssigned": "Support assigné",
      "lastLogin": "Dernière connexion",
      "isActive": "Actif",
      "createdAt": "Créé le",
      "user": "Utilisateur",
      "roles": "Rôles",
      "status": "Statut",
      "twoFactor": "2FA",
      "updated": "Mis à jour",
      "actions": "Actions"
    },
    "actions": {
      "create": "Créer un utilisateur",
      "edit": "Modifier",
      "deactivate": "Désactiver",
      "activate": "Activer",
      "resetPassword": "Réinitialiser le mot de passe",
      "impersonate": "Se faire passer pour",
      "assignSale": "Assigner un commercial",
      "assignCs": "Assigner un support",
      "revokeCredit": "Révoquer le crédit",
      "editCredit": "Modifier la limite de crédit"
    },
    "filters": {
      "role": "Rôle",
      "roleType": "Type de rôle",
      "saleAssigned": "Commercial assigné",
      "csAssigned": "Support assigné",
      "status": "Statut",
      "search": "Rechercher par nom ou email",
      "allRoles": "Tous les rôles",
      "allStatuses": "Tous les statuts"
    },
    "tabs": {
      "details": "Détails",
      "permissions": "Permissions",
      "credit": "Crédit",
      "auditLog": "Journal d'audit"
    },
    "fields": {
      "fullName": "Nom complet",
      "email": "Email",
      "phone": "Téléphone",
      "role": "Rôle",
      "password": "Mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "isActive": "Actif"
    },
    "empty": {
      "title": "Aucun utilisateur trouvé",
      "body": "Ajustez vos filtres ou créez un nouvel utilisateur."
    },
    "errors": {
      "duplicateEmail": "Un utilisateur avec cet email existe déjà",
      "weakPassword": "Le mot de passe doit faire au moins 12 caractères avec majuscules, minuscules et chiffres",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "cannotImpersonate": "Vous n'avez pas la permission de vous faire passer pour cet utilisateur",
      "cannotDeactivateSelf": "Vous ne pouvez pas désactiver votre propre compte"
    },
    "confirm": {
      "deactivate": "Désactiver cet utilisateur ? Il perdra l'accès immédiatement.",
      "resetPassword": "Envoyer un email de réinitialisation à cet utilisateur ?",
      "impersonate": "Se faire passer pour cet utilisateur ? Vos actions seront journalisées."
    },
    "page": {
      "heading": "Gestion des comptes admin",
      "subtitleWithTotal": "Gérez les rôles, la suspension, la réinitialisation 2FA et l'usurpation. {{total}} utilisateurs au total."
    },
    "search": {
      "placeholder": "Rechercher par email ou nom…"
    },
    "rowActions": {
      "grant": "Accorder",
      "revoke": "Révoquer",
      "suspend": "Suspendre",
      "unsuspend": "Réactiver",
      "reset2fa": "Réinitialiser 2FA",
      "selfGuard": "Vous ne pouvez pas modifier votre propre compte"
    },
    "twoFactor": {
      "enabledTitle": "2FA activé",
      "disabledTitle": "2FA non activé",
      "badgeOn": "2FA",
      "badgeOff": "Off"
    },
    "avatar": {
      "viewAlt": "Voir l'avatar de {{name}}"
    },
    "roleOptions": {
      "superadmin": "Superadmin",
      "admin": "Admin",
      "support": "Support",
      "saler": "Commercial",
      "manager": "Manager",
      "accountant": "Comptable",
      "affiliate": "Affilié"
    },
    "accountTypes": {
      "merchant": "Marchand",
      "vendor": "Fournisseur",
      "affiliate": "Affilié"
    },
    "statusLabels": {
      "active": "Actif",
      "pending_otp": "Non vérifié",
      "pending_approval": "En attente d'approbation",
      "pending_survey": "En attente de sondage",
      "suspended": "Suspendu",
      "banned": "Banni",
      "deleted": "Supprimé",
      "inactive": "Inactif"
    },
    "drawer": {
      "aria": "Détails du compte de {{name}}",
      "close": "Fermer",
      "closeAria": "Fermer le panneau",
      "viewAvatarAria": "Voir l'avatar de {{name}}",
      "fields": {
        "status": "Statut",
        "twoFactor": "2FA",
        "roles": "Rôles",
        "id": "ID",
        "createdAt": "Créé le",
        "updatedAt": "Modifié le",
        "lastLoginAt": "Dernière connexion",
        "avatarUrl": "URL de l'avatar"
      },
      "neverLoggedIn": "Jamais",
      "avatarFallback": "— (initiales par défaut)",
      "viewFull": "Voir tous les détails →",
      "fullIncludes": "Inclut permissions, activité, sessions"
    },
    "roleDialog": {
      "titleGrant": "Accorder un rôle — {{name}}",
      "titleRevoke": "Révoquer un rôle — {{name}}",
      "roleLabel": "Rôle",
      "rolePlaceholder": "Choisir un rôle…",
      "noRevocableRoles": "Cet utilisateur n'a aucun rôle à révoquer.",
      "reasonLabel": "Motif (audit, 10-500 caractères)",
      "cancel": "Annuler",
      "grant": "Accorder",
      "revoke": "Révoquer"
    },
    "confirmAction": {
      "suspendTitle": "Suspendre {{name}} ?",
      "unsuspendTitle": "Réactiver {{name}} ?",
      "reset2faTitle": "Réinitialiser la 2FA de {{name}} ?",
      "suspendDesc": "Se propage aux membres de l'équipe. Toutes les sessions sont révoquées.",
      "unsuspendDesc": "Restaure l'utilisateur à l'état Actif.",
      "reset2faDesc": "Efface l'enrôlement TOTP + les codes de récupération. Sensible Tier A.",
      "reasonPlaceholder": "Motif (10-500 caractères, journal d'audit)",
      "confirmLabel": "Confirmer",
      "reasonRequiredTitle": "Motif requis",
      "reasonRequiredDesc": "Minimum 10 caractères pour le journal d'audit."
    },
    "toast": {
      "loadFailTitle": "Échec du chargement des utilisateurs",
      "networkErrorTitle": "Erreur réseau",
      "unknown": "Inconnu",
      "actionFailTitle": "Échec de l'action",
      "unknownError": "Erreur inconnue",
      "suspendedTitle": "Utilisateur suspendu",
      "unsuspendedTitle": "Utilisateur réactivé",
      "reset2faTitle": "2FA de l'utilisateur réinitialisée",
      "roleUpdateFailTitle": "Échec de la mise à jour du rôle",
      "roleGrantedTitle": "Rôle accordé",
      "roleRevokedTitle": "Rôle révoqué"
    },
    "createDialog": {
      "title": "Créer un compte administrateur",
      "fields": {
        "email": "E-mail",
        "displayName": "Nom d'affichage",
        "role": "Rôle"
      },
      "roleOptions": {
        "admin": "Admin",
        "support": "Support Admin",
        "saler": "Commercial",
        "manager": "Manager",
        "accountant": "Comptable",
        "affiliate": "Affilié"
      },
      "checkbox": {
        "title": "Envoyer l'e-mail d'invitation",
        "onLabel": "Envoyer l'e-mail d'invitation juste après la création du compte",
        "offLabel": "Ne pas envoyer l'e-mail d'invitation (l'admin l'enverra plus tard)",
        "help": "Décochez pour créer le compte d'abord et envoyer l'e-mail d'invitation plus tard depuis la page de détail."
      },
      "submitInvite": "Créer et envoyer l'invitation",
      "submitInviteLoading": "Création et envoi de l'invitation…",
      "submitNoInvite": "Créer (sans invitation)",
      "submitNoInviteLoading": "Création…",
      "toast": {
        "successInvite": "Compte créé et e-mail d'invitation envoyé (1 envoyé avec succès)",
        "successNoInvite": "Compte créé (e-mail d'invitation non envoyé)",
        "failTitle": "Impossible de créer le compte",
        "failDesc": "Le réseau n'a pas répondu."
      }
    }
  },
  "detail": {
    "back": "Retour aux utilisateurs",
    "backToList": "Retour à la liste",
    "missingId": "Identifiant de compte manquant dans l'URL.",
    "loadError": "Impossible de charger les détails du compte : {{message}}",
    "unknownError": "Erreur inconnue.",
    "additionalRoles": "+ {{count}} rôle(s) supplémentaire(s)",
    "selfBanner": "Ceci est votre propre compte — vous ne pouvez pas vous verrouiller ni déconnecter toutes vos sessions ici.",
    "tabs": {
      "profile": "Profil",
      "permissions": "Rôles et permissions",
      "activity": "Activité",
      "sessions": "Sessions"
    },
    "statusLabels": {
      "active": "Actif",
      "inactive": "Suspendu",
      "locked": "Verrouillé"
    },
    "activity": {
      "totalPrefix": "Total",
      "totalSuffix": "activités.",
      "categoryOptions": {
        "all": "Toute activité",
        "login": "Connexion",
        "role_change": "Changement de rôle",
        "security": "Sécurité",
        "page_visit": "Pages récentes"
      },
      "categoryBadge": {
        "login": "Connexion",
        "role_change": "Rôle",
        "security": "Sécurité",
        "page_visit": "Visite"
      },
      "loadError": "Impossible de charger l'activité :",
      "empty": "Aucune activité dans cette catégorie pour le moment.",
      "columns": {
        "type": "Type",
        "event": "Événement",
        "detail": "Détails",
        "ipDevice": "IP / Appareil",
        "time": "Heure"
      },
      "pageLabel": "Page :",
      "loadingMore": "Chargement...",
      "loadMore_one": "Charger {{count}} ligne de plus",
      "loadMore_other": "Charger {{count}} lignes de plus",
      "events": {
        "ADMIN_ROLE_CREATE": "Rôle admin créé",
        "ADMIN_ROLE_DELETE": "Rôle admin supprimé",
        "ADMIN_ROLE_UPDATE": "Rôle admin mis à jour",
        "ADMIN_USER_2FA_SETUP": "2FA activée pour l'utilisateur",
        "ADMIN_USER_CREATE": "Compte admin créé",
        "ADMIN_USER_ROLE_GRANT_INITIAL": "Rôle initial attribué",
        "AUTH_2FA_CHALLENGE": "Défi 2FA émis",
        "AUTH_2FA_DISABLED": "2FA désactivée",
        "AUTH_2FA_SETUP": "Configuration 2FA",
        "AUTH_2FA_VERIFY": "2FA vérifiée",
        "AUTH_BILLING_UPDATE": "Infos de facturation mises à jour",
        "AUTH_IMPERSONATE_START": "Usurpation d'identité démarrée",
        "AUTH_LOGIN": "Connexion",
        "AUTH_LOGIN_FAILED": "Échec de connexion",
        "AUTH_LOGIN_LOCKED": "Compte verrouillé après échecs de connexion",
        "AUTH_LOGOUT": "Déconnexion",
        "AUTH_PASSWORD_CHANGE": "Mot de passe modifié",
        "AUTH_PROFILE_UPDATE": "Profil mis à jour",
        "AUTH_REFRESH": "Session actualisée",
        "AUTH_REFRESH_FAILED": "Échec de l'actualisation de session",
        "AUTH_REGISTER": "Compte enregistré",
        "AUTH_SESSION_REVOKED": "Session révoquée",
        "AUTH_SURVEY_SUBMIT": "Enquête envoyée",
        "AUTH_USER_2FA_RESET": "2FA réinitialisée pour l'utilisateur",
        "AUTH_USER_ROLE_GRANT": "Rôle attribué",
        "AUTH_USER_ROLE_REVOKE": "Rôle révoqué",
        "AUTH_USER_SUSPEND": "Utilisateur suspendu",
        "AUTH_USER_UNSUSPEND": "Utilisateur réactivé",
        "AUTH_USER_UPDATE": "Utilisateur mis à jour",
        "AUTH_VENDOR_APPROVE": "Fournisseur approuvé",
        "AUTH_WS_SUBSCRIBE_DENIED": "Abonnement temps réel refusé",
        "EMAIL_TEMPLATE_CREATE": "Modèle d'e-mail créé",
        "FRAUD_SETTINGS_UPDATED": "Paramètres antifraude mis à jour",
        "INVENTORY_OVERVIEW_VIEW": "Aperçu du stock consulté",
        "INVENTORY_REPORT_AGING_EXPORT": "Rapport d'ancienneté exporté",
        "INVENTORY_REPORT_MOVEMENT_EXPORT": "Rapport de mouvements exporté",
        "INVENTORY_REPORT_STOCK_LEVEL_EXPORT": "Rapport de niveau de stock exporté",
        "INVENTORY_REPORT_TURNOVER_EXPORT": "Rapport de rotation exporté",
        "INVENTORY_REPORT_VALUATION_EXPORT": "Rapport de valorisation exporté",
        "INVENTORY_STOCK_VIEW": "Liste de stock consultée",
        "KYC_DOCUMENT_APPROVED": "Document KYC approuvé",
        "LEGAL_ENTITY_CREATED": "Entité juridique créée",
        "PRODUCT_APPROVAL_APPROVED": "Produit approuvé",
        "SYSTEM_BACKUP_TRIGGERED": "Sauvegarde déclenchée",
        "VENDOR_BANK_VERIFIED": "Compte bancaire fournisseur vérifié",
        "admin_invoice_pdf_download": "PDF de facture téléchargé",
        "admin_payment_request_create": "Demande de paiement créée",
        "admin_payment_request_pdf_download": "PDF de demande de paiement téléchargé",
        "approval_request_executed": "Demande d'approbation exécutée",
        "approval_request_rejected": "Demande d'approbation rejetée",
        "approval_request_voted": "Vote sur demande d'approbation",
        "billing_invoice_manually_generated": "Facture générée manuellement",
        "billing_mode_switched": "Mode de facturation changé",
        "billing_refund_task_completed": "Tâche de remboursement terminée",
        "billing_address_create": "Adresse de facturation créée",
        "blueprint_create": "Blueprint créé",
        "blueprint_update": "Blueprint mis à jour",
        "invoice_pdf_download": "PDF de facture téléchargé",
        "merchant_invoice_created": "Facture marchand créée",
        "payout_approved": "Paiement approuvé",
        "payout_mark_transferred": "Paiement marqué transféré",
        "payout_rejected": "Paiement rejeté",
        "products_special_create": "Produit spécial créé",
        "products_special_update_assignments": "Affectations de produit spécial mises à jour",
        "queue_pause": "File d'attente mise en pause",
        "settings_update": "Paramètres mis à jour",
        "support_ticket_created": "Ticket de support créé",
        "support_ticket_escalated": "Ticket de support escaladé",
        "support_ticket_updated": "Ticket de support mis à jour",
        "support_ticket_message_created": "Réponse ajoutée au ticket",
        "vendor_capacity_current_active_changed": "Capacité active du fournisseur modifiée"
      },
      "targetLabel": "Cible",
      "noDetail": "Aucun détail supplémentaire"
    },
    "permissions": {
      "description": "Permissions effectives — fusionnées depuis le rôle de base et les attributions supplémentaires. Groupées par domaine.",
      "emptyNoPerms": "Ce compte n'a encore aucune permission accordée."
    },
    "profile": {
      "fields": {
        "name": "Nom d'affichage",
        "email": "E-mail",
        "primaryRole": "Rôle principal",
        "status": "Statut"
      },
      "statusOptions": {
        "active": "Actif",
        "inactive": "Temporairement verrouillé",
        "locked": "Verrouillé définitivement"
      },
      "selfLockHint": "Vous ne pouvez pas verrouiller votre propre compte.",
      "roleManagedHint": "Géré via Accorder/Révoquer un rôle dans la liste des utilisateurs.",
      "statusManagedHint": "Géré via Suspendre/Réactiver dans la liste des utilisateurs.",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement...",
      "toast": {
        "updateFailTitle": "Échec de la mise à jour",
        "updateFailDesc": "Impossible d'enregistrer les modifications.",
        "savedTitle": "Enregistré",
        "savedDesc": "Profil du compte mis à jour."
      }
    },
    "sessions": {
      "lastLogin": "Dernière connexion",
      "lastIp": "Dernière IP",
      "activeHeading": "Sessions actives",
      "activeAt": "Dernière activité",
      "loading": "Chargement des sessions…",
      "loadError": "Impossible de charger les sessions.",
      "empty": "Aucune session active.",
      "unknownDevice": "Appareil inconnu",
      "revokeAllHeading": "Déconnecter toutes les sessions",
      "revokeAllDesc": "Cette action révoque toutes les sessions de connexion actives du compte. L'utilisateur devra se reconnecter depuis tous ses appareils.",
      "selfNote": "Vous consultez votre propre compte — vous ne pouvez pas déconnecter vos propres sessions ici. Utilisez le bouton Déconnexion dans la barre de navigation si nécessaire.",
      "revokeAllBtn": "Déconnecter toutes les sessions",
      "processing": "Traitement...",
      "confirmTitle": "Confirmer la déconnexion de toutes les sessions",
      "confirmDescLine1": "Voulez-vous vraiment révoquer toutes les sessions actives de ce compte ? L'utilisateur devra se reconnecter sur chaque appareil.",
      "confirmDescLine2": "L'action sera enregistrée dans le journal d'audit.",
      "confirmLabel": "Tout déconnecter",
      "toast": {
        "revokedTitle": "Sessions déconnectées",
        "revokedDesc_one": "{{count}} session active déconnectée.",
        "revokedDesc_other": "{{count}} sessions actives déconnectées.",
        "failTitle": "Échec de la déconnexion des sessions",
        "failDesc": "Impossible de déconnecter les sessions."
      }
    }
  },
  "impersonate": {
    "button": "Se faire passer pour",
    "prompt": "Se faire passer pour {{name}}\n\nIndiquez un motif (journal d'audit, 10-500 caractères) :",
    "reasonTooShortTitle": "Motif trop court",
    "reasonTooShortDesc": "Minimum 10 caractères requis pour l'audit.",
    "failedTitle": "Échec de l'usurpation",
    "invalidResponseTitle": "Réponse d'usurpation invalide",
    "invalidResponseDesc": "Le serveur n'a pas renvoyé de redirectUrl.",
    "networkErrorTitle": "Erreur réseau",
    "unknown": "Inconnu"
  },
  "merchantCredit": {
    "heading": "Historique de crédit",
    "description": "Tout le crédit accordé à ce marchand.",
    "grantNew": "Accorder un nouveau crédit",
    "statusLabel": "Statut :",
    "clear": "Effacer",
    "status": {
      "active": "Actif",
      "overdue": "En retard",
      "expired": "Expiré",
      "revoked": "Révoqué"
    },
    "columns": {
      "status": "Statut",
      "limit": "Limite",
      "remaining": "Restant",
      "period": "Période (jours)",
      "start": "Début",
      "end": "Fin",
      "created": "Créé le",
      "createdBy": "Créé par",
      "actions": "Actions"
    },
    "loading": "Chargement de l'historique de crédit…",
    "empty": {
      "title": "Ce marchand n'a pas encore de crédit",
      "bodyWithName": "{{name}} n'a pas encore d'historique de crédit.",
      "body": "Aucun historique de crédit pour le moment.",
      "cta": "Accorder le premier crédit"
    },
    "filteredEmpty": "Aucun crédit ne correspond au filtre sélectionné.",
    "rowActions": {
      "edit": "Modifier",
      "revoke": "Révoquer",
      "viewDetails": "Voir les détails",
      "hide": "Masquer"
    },
    "tx": {
      "loading": "Chargement des transactions…",
      "error": "Échec du chargement des transactions : {{message}}",
      "unknown": "Inconnu",
      "empty": "Aucune transaction (CREDIT_USAGE / CREDIT_PAYMENT) sur ce crédit pour le moment.",
      "columns": {
        "type": "Type",
        "amount": "Montant",
        "when": "Quand",
        "txGroup": "tx_group"
      }
    }
  },
  "saleCs": {
    "title": "Assigner Commercial / Support",
    "titleWithName": "Assigner Commercial / Support — {{name}}",
    "saleLabel": "Personnel commercial (Sale staff)",
    "csLabel": "Personnel support (Customer Support)",
    "saleAria": "Commercial assigné",
    "csAria": "Support assigné",
    "none": "(aucun)",
    "loadingList": "Chargement de la liste…",
    "clearAria": "Effacer {{label}}",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "usersError": "Impossible de charger la liste du personnel admin (vérifiez la connexion ou les permissions)",
    "toast": {
      "success": "Commercial/Support assigné",
      "failTitle": "Échec de l'enregistrement Commercial/Support",
      "failFallback": "Échec de l'enregistrement"
    }
  },
  "revokeCredit": {
    "title": "Révoquer le crédit",
    "debtWarning": "Le montant déjà utilisé reste dû — le marchand devra rembourser {{amount}}.",
    "remainingNote": "Solde restant après révocation : {{amount}}. Cette action est irréversible.",
    "reasonLabel": "Motif de révocation (audit, {{min}}-{{max}} caractères)",
    "needMoreChars": "Encore {{count}} caractère(s) requis",
    "enoughChars": "Longueur suffisante",
    "cancel": "Annuler",
    "submit": "Révoquer",
    "submitting": "Révocation…",
    "reasonRequired": "Motif requis — minimum 10 caractères.",
    "failFallback": "Échec de la révocation",
    "toast": {
      "successTitle": "Crédit révoqué",
      "successDesc": "Historique mis à jour."
    }
  },
  "role": {
    "title": "Rôles",
    "subtitle": "Définitions des rôles admin",
    "columns": {
      "name": "Nom du rôle",
      "userCount": "Utilisateurs",
      "permissionCount": "Permissions",
      "isSystem": "Rôle système",
      "updatedAt": "Mis à jour"
    },
    "actions": {
      "create": "Créer un rôle",
      "edit": "Modifier les permissions",
      "duplicate": "Dupliquer",
      "delete": "Supprimer"
    },
    "fields": {
      "name": "Nom du rôle",
      "description": "Description",
      "permissions": "Permissions"
    },
    "errors": {
      "cannotDeleteSystem": "Les rôles système ne peuvent être supprimés",
      "cannotDeleteInUse": "Impossible de supprimer — le rôle est assigné à {{count}} utilisateur(s)",
      "duplicateName": "Un rôle avec ce nom existe déjà"
    },
    "readOnlyBuiltIn": "Rôle système — lecture seule.",
    "readOnlyNoPermission": "Vous n'avez pas le droit de modifier (role:manage requis).",
    "editor": {
      "titleView": "Voir le rôle : {{name}}",
      "titleEdit": "Modifier le rôle : {{name}}",
      "titleCreate": "Créer un rôle personnalisé",
      "createBtn": "Créer le rôle",
      "builtInBanner": "Rôle système (intégré) — lecture seule, non modifiable. Pour accorder des permissions personnalisées, créez un nouveau rôle à partir du pool de permissions Admin.",
      "catalogLoadError": "Impossible de charger le catalogue des permissions. Rechargez la page.",
      "loadingCatalog": "Chargement du catalogue de permissions…",
      "fields": {
        "code": "Code du rôle (slug)",
        "name": "Nom du rôle",
        "description": "Description (facultatif)"
      },
      "placeholders": {
        "code": "ex : finance_ops",
        "name": "ex : Finance Operations",
        "description": "Objectif du rôle et périmètre de l'équipe"
      },
      "permissionsLegend": "Permissions (Permissions de données)",
      "permissionsHelp": "L'arbre des permissions est groupé par module. Les permissions avec un seuil de montant affichent un sélecteur de palier — choisir le palier illimité accorde aussi automatiquement le seuil de base.",
      "selectedCountPrefix": "Sélectionnées :",
      "selectedCountSuffix": "permissions",
      "validation": {
        "codeMin": "Le code du rôle doit comporter au moins 2 caractères",
        "codeMax": "Le code du rôle doit comporter au plus 50 caractères",
        "codePattern": "Le code du rôle ne peut contenir que des minuscules, chiffres et traits de soulignement",
        "nameMin": "Le nom du rôle doit comporter au moins 2 caractères",
        "nameMax": "Le nom du rôle doit comporter au plus 200 caractères",
        "descMax": "La description doit comporter au plus 2000 caractères",
        "permMin": "Au moins 1 permission est requise pour le rôle"
      },
      "toast": {
        "savedTitle": "Rôle enregistré",
        "createdTitle": "Rôle créé",
        "savedDesc": "Le rôle « {{name}} » a été mis à jour.",
        "savedDescCount": "Rôle « {{name}} » mis à jour — {{granted}} accordée(s), {{revoked}} révoquée(s).",
        "createdDesc": "Le rôle « {{name}} » a été créé.",
        "saveFail": "Échec de l'enregistrement du rôle."
      }
    },
    "dataPerms": {
      "selectRole": "Sélectionnez un rôle à gauche pour voir sa configuration de permissions de données.",
      "loading": "Chargement de la configuration des permissions de données…",
      "loadError": "Impossible de charger la configuration des permissions de données",
      "heading": "Permissions de données (par colonne)",
      "editableHint": "La configuration s'applique à liste / détail / export / rapport.",
      "noScreens": "Aucun écran n'a encore enregistré de configuration de colonnes.",
      "selectAllAria": "Sélectionner toutes les colonnes pour {{name}}",
      "all": "Tout",
      "colsSuffix": "colonnes",
      "toast": {
        "savedDesc": "Permissions de données du rôle mises à jour avec succès.",
        "failTitle": "Échec de l'enregistrement",
        "failDesc": "Impossible d'enregistrer les permissions de données. Veuillez réessayer."
      }
    },
    "matrix": {
      "selectRole": "Sélectionnez un rôle à gauche pour voir la matrice des permissions.",
      "loading": "Chargement de la matrice des permissions…",
      "loadError": "Impossible de charger la matrice des permissions",
      "heading": "Matrice des permissions",
      "selectedCount": "{{selected}}/{{total}} permissions sélectionnées.",
      "toast": {
        "savedDesc": "Permissions du rôle mises à jour avec succès.",
        "failTitle": "Échec de l'enregistrement",
        "failDesc": "Impossible d'enregistrer les permissions. Veuillez réessayer."
      }
    },
    "list": {
      "heading": "Rôles",
      "subtitle": "Rôles intégrés (Super Admin / Admin / Comptable / Support) ainsi que des rôles personnalisés créés à partir du pool de permissions Admin.",
      "subtitleGate": "Gérer les rôles et permissions pour admin / super admin.",
      "noReadPermission": "Vous n'avez pas le droit de voir la liste des rôles admin (role:read requis). Contactez un superadmin.",
      "createBtn": "Créer un rôle personnalisé",
      "readOnlyBanner": "Vous pouvez seulement consulter la liste (lecture seule). Créer / modifier / supprimer un rôle nécessite role:manage — contactez un superadmin.",
      "columns": {
        "name": "Nom du rôle",
        "description": "Description",
        "type": "Type",
        "permissionCount": "Permissions",
        "memberCount": "Membres",
        "actions": "Actions"
      },
      "loading": "Chargement de la liste des rôles…",
      "empty": "Aucun rôle pour le moment. Contactez un superadmin pour les initialiser.",
      "typeBuiltIn": "Système",
      "typeCustom": "Personnalisé",
      "viewPerms": "Voir les permissions",
      "edit": "Modifier",
      "delete": "Supprimer",
      "deleteBlockedTitle": "{{count}} membres utilisent encore ce rôle — déplacez-les avant de supprimer",
      "confirmDeleteTitle": "Supprimer le rôle « {{name}} » ?",
      "confirmDeleteDesc": "Le rôle {{code}} sera supprimé définitivement. Cette action est enregistrée dans le journal d'audit et est irréversible.",
      "confirmBlockedDesc": "{{count}} membres utilisent encore ce rôle — déplacez-les avant de supprimer. Chaque admin doit avoir au moins 1 rôle.",
      "cannotDelete": "Suppression impossible",
      "confirmDeleteLabel": "Supprimer le rôle",
      "toast": {
        "deletedTitle": "Rôle supprimé",
        "deletedDesc": "Le rôle a été retiré du système.",
        "cannotDeleteTitle": "Impossible de supprimer le rôle",
        "hasMembersWithCount": "{{count}} membres utilisent encore ce rôle — déplacez-les avant de supprimer.",
        "hasMembers": "Le rôle a encore des membres — déplacez-les avant de supprimer.",
        "deleteFailTitle": "Échec de la suppression du rôle",
        "deleteFailFallback": "Échec de la suppression du rôle."
      }
    },
    "permEditor": {
      "title": "Modifier les permissions du rôle : {{name}}",
      "defaultReason": "Mise à jour des permissions du rôle {{role}}",
      "previewSaveError": "Le rôle n'a pas d'identifiant réel — mode aperçu, enregistrement impossible.",
      "crossScopeError": "Certaines permissions sont hors du périmètre admin. Le serveur les a refusées — veuillez désélectionner les permissions concernées.",
      "saveFail": "Échec de l'enregistrement",
      "previewBannerTitle": "Mode aperçu.",
      "previewBannerBody": "Le chargement et l'enregistrement des permissions ne sont pas encore disponibles. L'interface des groupes de permissions (Billing, Audit, …) est prête pour l'aperçu.",
      "applyWarningPrefix": "S'applique immédiatement à",
      "applyWarningSuffix": "utilisateurs admin.",
      "catalogEmpty": "Le système n'a pas initialisé le catalogue de permissions. Contactez un superadmin.",
      "legend": "Permissions (par module)",
      "newBadge": "Nouveau",
      "impersonateBlocked": "Personnification bloquée",
      "reasonLabel": "Motif du changement (journal d'audit)",
      "reasonPlaceholder": "ex : Accorder les permissions de facturation à l'équipe finance selon le ticket #1234",
      "validation": {
        "minOne": "Sélectionnez au moins 1 permission pour le rôle.",
        "crossScope": "Les permissions de périmètre merchant ne peuvent pas être attribuées à un rôle admin : {{keys}}",
        "reasonMin": "Le motif doit comporter au moins 10 caractères (exigence du journal d'audit).",
        "reasonMax": "Le motif doit comporter au plus 500 caractères."
      },
      "toast": {
        "savedTitle": "Permissions du rôle enregistrées",
        "savedDesc": "+{{added}} permissions · -{{removed}} permissions"
      }
    }
  },
  "permission": {
    "title": "Permissions",
    "categories": {
      "finance": "Finance",
      "catalog": "Catalogue",
      "orders": "Commandes",
      "users": "Utilisateurs et rôles",
      "support": "Support",
      "merchant": "Gestion des marchands",
      "vendor": "Gestion des vendeurs",
      "system": "Système"
    },
    "tree": {
      "expandAll": "Tout développer",
      "collapseAll": "Tout réduire",
      "selectAll": "Tout sélectionner",
      "clearAll": "Tout effacer",
      "tierUnlimited": "Illimité",
      "tierUpTo": "≤ {{amount}} USD",
      "empty": "Le catalogue de permissions est vide. Contactez un superadmin pour l'initialiser.",
      "amountGateBadge": "Plafonné par montant",
      "amountGateHint": "Choisissez le seuil maximum pour ce rôle.",
      "thresholdAria": "Seuil pour {{path}}",
      "noGrant": "Non accordé"
    },
    "customBadge": "Personnalisé",
    "domainLabels": {
      "invoice": "Facture",
      "credit_memo": "Note de crédit",
      "refund_task": "Tâche de remboursement",
      "aging_report": "Rapport des créances",
      "legal_entity": "Entité juridique",
      "pricing": "Tarification",
      "products": "Produits",
      "product": "Produits",
      "support": "Support",
      "user": "Gestion des utilisateurs",
      "admin_user": "Gestion des admins",
      "system": "Système",
      "dashboard": "Tableau de bord",
      "orders": "Commandes",
      "vendors": "Fournisseurs",
      "merchants": "Merchants",
      "stores": "Boutiques",
      "finance": "Finance",
      "impersonate": "Personnification"
    }
  },
  "common": {
    "cancel": "Annuler",
    "save": "Enregistrer les modifications",
    "saving": "Enregistrement…",
    "close": "Fermer",
    "saved": "Enregistré",
    "loading": "Chargement…",
    "unknownError": "Erreur inconnue.",
    "all": "Tout",
    "delete": "Supprimer",
    "continue": "Continuer",
    "retry": "Réessayer",
    "back": "Retour"
  },
  "adminMgmt": {
    "twoFa": {
      "title": "Activer la 2FA pour {{name}}",
      "wizardAria": "Assistant d'activation 2FA",
      "stepsAria": "Étapes d'activation 2FA",
      "steps": {
        "setup": "Scanner le QR",
        "verify": "Saisir le code TOTP",
        "done": "Enregistrer les codes de récupération"
      },
      "generatingSecret": "Génération du secret 2FA…",
      "qrAlt": "Code QR 2FA",
      "scanHint": "Scannez le QR avec Google Authenticator / Authy / 1Password, ou saisissez le secret ci-dessous manuellement.",
      "continue": "Continuer",
      "setupErrorFallback": "Impossible d'initialiser la 2FA.",
      "retry": "Réessayer",
      "totpLabel": "Code à 6 chiffres de votre application d'authentification",
      "back": "Retour",
      "verifying": "Vérification…",
      "verify": "Vérifier",
      "recoveryIntro_one": "Enregistrez le {{count}} code de récupération ci-dessous en lieu sûr. Si vous perdez l'accès à votre application d'authentification, c'est le SEUL moyen de vous reconnecter. Chaque code est utilisable une seule fois.",
      "recoveryIntro_other": "Enregistrez les {{count}} codes de récupération ci-dessous en lieu sûr. Si vous perdez l'accès à votre application d'authentification, c'est le SEUL moyen de vous reconnecter. Chaque code est utilisable une seule fois.",
      "copy": "Copier",
      "downloadTxt": "Télécharger le fichier .txt",
      "ackLabel_one": "J'ai enregistré le {{count}} code de récupération en lieu sûr.",
      "ackLabel_other": "J'ai enregistré les {{count}} codes de récupération en lieu sûr.",
      "ackDownloaded": " (Fichier téléchargé)",
      "finish": "Terminer",
      "recoveryFile": {
        "title": "Printway — Codes de récupération 2FA",
        "userPrefix": "Utilisateur :",
        "generatedPrefix": "Généré le :",
        "instruction": "Conservez ce fichier en lieu sûr. Chaque code est utilisable une seule fois."
      },
      "toast": {
        "setupFailTitle": "Impossible d'initialiser la 2FA",
        "verifyFailTitle": "Code 2FA incorrect",
        "copiedTitle_one": "{{count}} code de récupération copié",
        "copiedTitle_other": "{{count}} codes de récupération copiés",
        "copyFailTitle": "Le navigateur a refusé l'accès au presse-papiers",
        "copyFailDesc": "Veuillez télécharger le fichier des codes de récupération à la place."
      }
    },
    "create": {
      "title": "Créer un compte admin",
      "dialogAria": "Créer un nouvel admin",
      "fields": {
        "email": "E-mail",
        "name": "Nom d'affichage",
        "role": "Rôle"
      },
      "emailHint": "Utilisez un e-mail d'entreprise (@printway.work, @printway.io, @techagents.one). Un e-mail d'invitation avec un lien de première connexion sera envoyé à cette adresse.",
      "roleHint": "Super Admin n'est pas disponible ici — promouvez via l'action sur la ligne avec un motif d'audit.",
      "autoGenTitle": "Générer automatiquement un mot de passe temporaire",
      "autoGenHelp": "Le mot de passe sera envoyé via l'e-mail d'invitation. Le compte n'est actif qu'après avoir terminé les 3 étapes d'activation 2FA.",
      "roleOptions": {
        "admin": "Admin",
        "support_admin": "Support Admin",
        "accountant": "Comptable",
        "saler": "Commercial",
        "manager": "Manager"
      },
      "submit": "Créer et activer la 2FA",
      "submitLoading": "Création…",
      "toast": {
        "successTitle": "Admin créé — e-mail d’invitation envoyé",
        "failTitle": "Impossible de créer l'admin",
        "successDescription": "{{email}} ({{role}}) définira un mot de passe et activera la 2FA à la première connexion."
      },
      "emailPlaceholder": "nom@printway.work"
    }
  },
  "customRoles": {
    "title": "Rôles personnalisés",
    "subtitle": "Attribuer des rôles admin personnalisés (permissions en plus du rôle principal).",
    "empty": "Aucun rôle personnalisé attribué.",
    "placeholder": "Sélectionner un rôle personnalisé…",
    "grantBtn": "Attribuer",
    "granted": "Rôle personnalisé attribué",
    "grantError": "Impossible d’attribuer le rôle",
    "revoked": "Rôle personnalisé retiré",
    "revokeError": "Impossible de retirer le rôle",
    "removeAria": "Retirer le rôle {{role}}"
  }
}
